import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Pages } from 'core/pages';

const PlayerRankingDashboard = lazy(() => import('./Dashboard'));
const PlayerRankingCreate = lazy(() => import('./Create'));
const PlayerRankingUpdate = lazy(() => import('./UpdatePlayerRanking'));
const PlayerRankingVersion = lazy(() => import('./PlayerRankingVersion'));
const PlayerRankingRead = lazy(() => import('./ResourcePage'));
const PlayerRankingList = lazy(() => (import('./PlayerRankingList')));
export function PlayerRankingRoutes() {
  return (
    <Routes>
      <Route path={Pages.sports.cricket.PlayerRanking.meta.path}>
        <Route
          index
          element={(<PlayerRankingDashboard />)}
        />
        <Route
          path={Pages.sports.cricket.PlayerRanking.create.meta.path}
          element={(<PlayerRankingCreate />)}
        />
        <Route
          path={Pages.sports.cricket.PlayerRanking.update.meta.path}
          element={(<PlayerRankingUpdate />)}
        />
        <Route
          path={Pages.sports.cricket.PlayerRanking.read.meta.path}
          element={(<PlayerRankingRead />)}
        />
        <Route
          path={Pages.sports.cricket.PlayerRanking.list.meta.path}
          element={(<PlayerRankingList />)}
        />
        <Route
          path={Pages.sports.cricket.PlayerRanking.version.meta.path}
          element={(<PlayerRankingVersion />)}
        />

      </Route>
    </Routes>

  );
}
